import { AxiosError, isAxiosError } from "axios";
import _ from "lodash";

import { reportUnexpectedApiErrorMessage } from "@services/sentry/captureException";

export default function parseApiErrorMessage(error: Error | AxiosError) {
  if (isAxiosError(error)) {
    if (error.message?.includes("timeout") || error.code === "ETIMEDOUT") {
      return "The request took too long. This is most likely due to a slow internet connection. Please check your connection and try again.";
    }
    if (/ECONNABORTED|ERR_NETWORK/i.test(error.code || "")) {
      return error.message;
    }
    if (typeof error.response?.data === "string") {
      // 500 errors in dev mode
      return error.response.data;
    }

    if (typeof error.response?.data?.message === "string") {
      // 401 invalid_token
      if (error.response.data.message === "invalid_token") {
        return "Your session has expired. Please log in and try again.";
      }
      return error.response.data.message;
    }

    if (
      Array.isArray(error.response?.data.errors) &&
      error.response?.data.errors[0].detail
    ) {
      return error.response.data.errors
        .map((e) => e.detail.replace(/^base /i, ""))
        .join("\n");
    }

    if (typeof error.response?.data.errors?.detail === "string") {
      // usually 500 server errors
      return error.response.data.errors.detail;
    }

    reportUnexpectedApiErrorMessage(error);
  }
  return error.message;
}

export const withBetterErrorMessage = (error: Error | AxiosError) => {
  error.message = parseApiErrorMessage(error);
  return error;
};
